export enum TechnicalTerm {
  STRONGEST = "STRONGEST",
  ADJACENT = "ADJACENT",
  ADJACENT_IN_THE_SAME_ROW = "ADJACENT_IN_THE_SAME_ROW",
  CONE = "CONE",
  BOARD_EFFECT = "BOARD_EFFECT"
}

export const TechnicalTerms = Object.values(TechnicalTerm)
